<script>
import AdaptsRelateFieldtype from './AdaptsRelateFieldtype.vue';

export default {

    mixins: [AdaptsRelateFieldtype]

};
</script>



// WEBPACK FOOTER //
// FormFieldtype.vue?4a2f5838